import React from 'react';
import ACardsGrid from '../../../../components/ACardGrid/ACardGrid';
import { useGetPermissions } from '../../../../layouts/customHook';
import { useHistory } from 'react-router-dom';
import MoneyIcon from "assets/img/svg/svgComponents/MoneyIcon";
import styles from "../../refundStyles.module.scss";

const RefundTrackerCard = () => {

    const history  = useHistory();

    const refundTrackerPermissions = useGetPermissions('refundTracker');
    
    const cardsInfo = [
        refundTrackerPermissions && {
            heading: 'Refund Tracker',
            subHeading: 'Track all the raised refunds',
            Icon: () => <div className={styles['money-icon-wrapper']}><MoneyIcon/></div>,
            onNextClick: () => history.push("/admin/refundTracker")
        }
    ]

    return ( 
        <ACardsGrid cardsInfo={cardsInfo} className='mt-3'/>
     );
}
 
export default RefundTrackerCard;